/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { HiDownload } from 'react-icons/hi';
import { MdSearch } from 'react-icons/md';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import TicketService from '../../services/ticket';
import DownLoadFile from '../../utils/DownLoadFile';
import { useToast } from '../../hooks/toast';
import { ArrayFilters, ReplacedTickets } from '../../interfaces/ticket';
import ReplacedTicketTable from './components/ReplacedTicketTable';
import Input from '../../components/Input';
import UpdateOrange from '../../assets/updateOrange.svg';
import getValidationErrors from '../../utils/getValidationErrors';
import AuthService from '../../services/auth';
import Modal from '../../components/Modal';
import { Row, Column, IconContainer } from '../../styles/components';

import {
  Container,
  Title,
  FiltersContainer,
  FormWrapper,
  ModalContent,
  LinkModal,
} from './styles';

const CardTicketReplaced: React.FC = () => {
  const services = { TicketService: new TicketService() };
  const authService = { AuthService: new AuthService() };
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const formRefRelatorio = useRef<FormHandles>(null);
  const { push } = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [titular, setTitular] = useState<any>();
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);

  const [replacedTickets, setReplacedTickets] = useState<ReplacedTickets>(
    {} as ReplacedTickets,
  );

  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  const getReplacedCards = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.TicketService.getTicketReplaced(filters);
      setReplacedTickets(response.data);
      setPerPage(response.data.ListaDeCartoesQuantidade);
      setTotalRows(response.data.ListaDeCartoesTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleNumberOrderFilter = useCallback(
    (data: any) => {
      setFilters({
        filters: [...filters.filters, { 'code-ticket-old': data.search }],
      });
    },
    [filters],
  );

  function relatorio() {
    push('/agendado');
  }

  const handleReport = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getTicketReplacedReport(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `BloqueadosSemSegundaVia.${type}`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possivel Executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  const RelatorioAgendados = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      const response = await services.TicketService.getTicketReplacedReport(
        reportFilters,
        type,
      );
    } catch (err: any) {
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possivel Executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendados('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendados('pdf');
  }, []);

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
          ],
        };

        await services.TicketService.getTicketReplacedReport(
          reportFilters,
          type,
        );

        addToast({
          type: 'success',
          title: 'Relatório exportado com sucesso, por favor, aguarde.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);

        addToast({
          type: 'error',
          title: `${err.response.data.message} ${err.response.data.sub_message}`,
        });
        const { ...error } = err;
        console.error(error);
      }
    },
    [titular],
  );

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
      }
    },
    [tipoRelatorio, titular],
  );

  useEffect(() => {
    getReplacedCards();
    getTitular();
  }, [filters]);

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <img src={UpdateOrange} alt="Cartões Substituídos" />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>Cartões Substituídos</Title>
        </Column>
      </Row>
      <Row>
        <Column small="12" medium="12" large="12">
          <FiltersContainer style={{ marginTop: '20px' }}>
            <div className="search">
              <Form ref={formRef} onSubmit={handleNumberOrderFilter}>
                <Input
                  id="search"
                  name="search"
                  type="number"
                  placeholder="Busca por Número do Cartão Antigo"
                />
                <Button
                  color="orange"
                  padding="1"
                  type="submit"
                  className="searchButton"
                >
                  <MdSearch size={20} />
                </Button>
              </Form>
            </div>
            <div className="buttonsContainer">
              <Button
                color="purple"
                padding="1"
                type="button"
                className="csv"
                onClick={() => {
                  return titular.AsyncReport === true
                    ? openModalCSV()
                    : handleReport('csv');
                }}
              >
                <HiDownload />
                GERAR CSV
              </Button>
              <Button
                color="purple"
                padding="1"
                type="button"
                className="pdf"
                onClick={() => {
                  return titular.AsyncReport === true
                    ? openModalPDF()
                    : handleReport('pdf');
                }}
              >
                <HiDownload />
                GERAR PDF
              </Button>
            </div>
          </FiltersContainer>
        </Column>
      </Row>

      <Row>
        <Column small="12" medium="12" large="12">
          <ReplacedTicketTable
            data={replacedTickets.ListaDeCartoes}
            columns={[
              {
                name: 'Cartão Antigo',
                selector: 'IdentificadorCartaoVTAntigo',
              },
              {
                name: 'Via',
                selector: 'CodigoPedidoDeSegundaVia',
                cell: ({ numViaAntigo }: any) => (
                  <div>{numViaAntigo || '--'}</div>
                ),
              },
              {
                name: 'Cartão Novo',
                selector: 'IdentificadorCartaoVTNovo',
              },
              {
                name: 'Via',
                selector: 'CodigoPedidoDeSegundaVia',
                cell: ({ numViaNovo }: any) => <div>{numViaNovo || '--'}</div>,
              },
            ]}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhum cartão substituido até o momento"
          />
        </Column>
      </Row>

      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}

      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default CardTicketReplaced;
